<template>
<div id="ui-login-wrapper">
    <header class="lang-dropdown-wrapper">
        <lang-dropdown :locales="locales" :selectedLocale="selectedOption" class="login-lang-dropdown" @localeChange="handleLocaleChangeEvent"></lang-dropdown>
    </header>
    <main id="js-login" class="login">
        <div class="login__logo-wrapper" :class="{ 'login__logo-wrapper--bg': !isDefaultStyle }">
            <img v-if="isDefaultStyle" class="login__logo" :src="require(`@/assets/images/${logoSrc}`)" alt="" />
        </div>
        <div class="login__form-wrapper">
            <div class="login__form">
                <img v-if="!isDefaultStyle" class="login__form-logo" :src="require(`@/assets/images/${logoSrc}`)" alt="" />
                <h1 class="login__form-heading" v-html="$t('login_welcome_title')"></h1>
                <p class="login__form-text" v-html="$t('login_welcome_text_html')"></p>
                <form class="login-form" v-on:submit.prevent="login">
                    <label :aria-label="$t('login_password')" class="login__password-input-label">
                        <input class="login__password-input" :class="{ 'login__password-input--error': error }" :placeholder="$t('login_password')" type="password" name="password" v-model.trim="password" @input="removeErrorAlert" />
                    </label>
                    <div role="alert" class="d-login-alert-error" v-if="error">
                        <i class="login-error-icon fas fa-exclamation-circle"></i>
                        {{ $t("password_error_message") }}
                    </div>
                    <ui-button id="js-login-btn" type="button" class="login-btn" @click="login()">
                        {{ $t("login_button") }}
                    </ui-button>
                </form>
            </div>
            <copyright-footer class="login-copyright" :locale="$i18n.locale"></copyright-footer>
        </div>
    </main>
</div>
</template>

<script>

import utils, {setPageTitle} from "@/common/utils";

import {processLogin} from "@/plugins/auth";
import LocaleSwitcher from "@/components/LocaleSwitcher.vue";
import UiButtonVue from "@/components/UiButton.vue";
import CopyRightLabel from "@/components/CopyRightLabel.vue";
import {
    isDefaultStyle,
    logoPath,
} from "@/config";
import {
    getpreferredLocales, 
    setCurrentLocale, 
} from "@/plugins/i18n";

export default {
    components: {
        "lang-dropdown": LocaleSwitcher,
        "ui-button": UiButtonVue,
        "copyright-footer": CopyRightLabel,
    },
    data() {
        return {
            isDefaultStyle: isDefaultStyle,
            error: null,
            password: null,
            locales: getpreferredLocales(),
            logoSrc: logoPath,
            selectedOption: this.$i18n.locale,
        };
    },
    beforeMount(){
        //let input_lang = this.$route.query.lang;
        //console.log("the input lang is: ", input_lang )
       // this.$i18n.locale = input_lang;
    },
    mounted() {
        utils.resizeOverlay("js-login");
        setPageTitle(this.$t('site_title'))
    },
    methods: {
        login() {
            processLogin(this, this.password);
        },
        removeErrorAlert() {
            this.error = false;
        },

         handleLocaleChangeEvent(locale){
            setCurrentLocale(locale)
            utils.handleLocaleChangeEvent(this,locale);
            setPageTitle(this.$t('site_title'))
        }
    },
};
</script>

<style lang="scss">
@import "../assets/styles/login.scss";
</style>
